import { Application } from '../../../../../types/api';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { defaultApplicantName } from '../../constants';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';

const {
  companyDocuments: { religiousOrganizationAttendance },
  systemPowerCompanyType,
  isPG,
  borrowerIsReligiousOrganization,
} = loanFormModel.formField;

export class ReligiousOrganizationAttendanceValidation
  implements ValidationSchema
{
  public name = religiousOrganizationAttendance.name;
  public label = religiousOrganizationAttendance.getLabel(defaultApplicantName);
  public dependsOn: string[] = [
    systemPowerCompanyType.name,
    borrowerIsReligiousOrganization.name,
    isPG.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };

  public when(
    systemPowerCompanyType: Application['solar_system_power_company_type'],
    borrowerIsReligiousOrganization: Application['is_religious_organization'],
    isPersonalGuarantor: Application['is_personal_guarantor'],
    schema
  ) {
    const required =
      systemPowerCompanyType === 'Non-Profit' &&
      borrowerIsReligiousOrganization === 'Yes' &&
      isPersonalGuarantor !== 'Yes';
    schema = FileNameValidationSchema(
      religiousOrganizationAttendance.name,
      required
    );
    if (required) schema = schema.required('This document is required');
    return schema;
  }
}
export default new Validation(new ReligiousOrganizationAttendanceValidation());
